const addInfo = {
    title: 'Vehicle',
    icon: 'vehicle'
}

const vehicleRouter = {
    path: '/vehicle',
    meta: {
        title: 'Vehicle',
        icon: 'vehicle',
        permission: ['vehicle_management']
    },
    children: [
        {
            path: 'manage-vehicle',
            component: () => import('@/views/vehicle/ManageVehicle/manage-vehicle'),
            name: 'ManageVehicle',
            meta: { title: 'ManageVehicle', parent: addInfo, permission: ['vehicle_enable'] }
        },
        {
            path: 'print-vehicle-qrs',
            component: () => import('@/views/vehicle/ManageVehicle/print-vehicle-qrs'),
            name: 'PrintVehicleQRs',
            hidden: true,
            meta: {title: 'PrintVehicleQRs', permission: ['vehicle_enable']}
        },
        {
            path: 'create-vehicle-form',
            component: () => import('@/views/vehicle/ManageVehicle/vehicle-form'),
            name: 'VehicleForm',
            hidden: true,
            meta: {
                title: 'VehicleForm',
                activeMenu: '/vehicle/manage-vehicle',
                enableBack: true,
                backPage: 'ManageVehicle',
                parent: addInfo,
                parentIcon: 'vehicle',
                permission: ['vehicle_create']
            }
        },
        {
            path: 'update-vehicle-form/:id?',
            component: () => import('@/views/vehicle/ManageVehicle/vehicle-form'),
            name: 'UpdateVehicleForm',
            hidden: true,
            meta: {
                title: 'VehicleForm',
                activeMenu: '/vehicle/manage-vehicle',
                enableBack: true,
                backPage: 'ManageVehicle',
                parent: addInfo,
                parentIcon: 'vehicle',
                permission: ['vehicle_update']
            }
        },
        {
            path: 'manage-tracker',
            component: () => import('@/views/vehicle/ManageTracker/manage-tracker'),
            name: 'ManageTracker',
            meta: { title: 'ManageTracker', parent: addInfo, permission: ['tracker_enable'] }
        },
        {
            path: 'fuel-calibration-form/:id?',
            component: () => import('@/views/vehicle/ManageTracker/fuel-calibration-form'),
            name: 'FuelCalibrationForm',
            hidden: true,
            meta: { title: 'FuelCalibrationForm', parent: addInfo, activeMenu: '/vehicle/manage-vehicle', enableBack: true, backPage: 'ManageVehicle', permission: ['update_fuel_calibration_enable'] }
        },
        {
            path: 'tracker-form/:id?',
            component: () => import('@/views/vehicle/ManageTracker/tracker-form'),
            name: 'TrackerForm',
            hidden: true,
            meta: { title: 'TrackerForm', parent: addInfo, activeMenu: '/vehicle/manage-tracker', enableBack: true, backPage: 'ManageTracker', permission: ['tracker_create', 'tracker_update', 'tracker_enable'] }
        },
        {
            path: 'maintenance-log',
            name: 'MaintenanceLog',
            meta: { title: 'MaintenanceLog', permission: ['vehicle_documentation_enable', 'service_record_enable'] },
            children: [
                {
                    path: 'details/:id',
                    component: () => import('@/views/vehicle/MaintenanceLog/maintenance-profile'),
                    name: 'MaintenanceProfile',
                    hidden: true,
                    meta: { title: 'MaintenanceProfile', parent: addInfo, enableBack: true, backPage: 'ServiceRecord', activeMenu: '/vehicle/maintenance-log/service-record', permission: ['service_record_enable'] }
                },  //permission
                {
                    path: 'overview',
                    component: () => import('@/views/vehicle/MaintenanceLog/overview'),
                    name: 'MaintenanceLogOverview',
                    meta: { title: 'Overview', parent: addInfo, permission: ['vehicle_documentation_enable', 'service_record_enable'] }
                },  //permission
                {
                    path: 'service-record',
                    component: () => import('@/views/vehicle/ServiceRecord/service-record'),
                    name: 'ServiceRecord',
                    meta: { title: 'ServiceRecord', parent: addInfo, permission: ['service_record_enable'] }
                },
                {
                    path: 'service-record-form/:id?',
                    component: () => import('@/views/vehicle/ServiceRecord/service-record-form'),
                    name: 'ServiceRecordForm',
                    hidden: true,
                    meta: { title: 'ServiceRecordForm', parent: addInfo, activeMenu: '/vehicle/maintenance-log/service-record', enableBack: true, backPage: 'ServiceRecord', permission: ['service_record_create'] }
                },
                {
                    path: 'update-service-record-form/:id?',
                    component: () => import('@/views/vehicle/ServiceRecord/service-record-form'),
                    name: 'UpdateServiceRecordForm',
                    hidden: true,
                    meta: { title: 'ServiceRecordForm', parent: addInfo, activeMenu: '/vehicle/maintenance-log/service-record', enableBack: true, backPage: 'ServiceRecord', permission: ['service_record_update'] }
                },
                {
                    path: 'view-service-record/:id?',
                    component: () => import('@/views/vehicle/ServiceRecord/view-service-record'),
                    name: 'ViewServiceRecord',
                    hidden: true,
                    meta: { title: 'ViewServiceRecord', parent: addInfo, activeMenu: '/vehicle/maintenance-log/service-record', enableBack: true, backPage: 'ServiceLog', permission: ['service_record_enable'] }
                },
                {
                    path: 'service-log',
                    component: () => import('@/views/vehicle/MaintenanceLog/service-log'),
                    name: 'ServiceLog',
                    meta: { title: 'ServiceLog', parent: addInfo , permission: ['service_record_enable'] }
                },  //permission
                {
                    path: 'vehicle-log',
                    component: () => import('@/views/vehicle/MaintenanceLog/vehicle-log'),
                    name: 'VehicleLog',
                    meta: { title: 'VehicleLog', parent: addInfo , permission: ['vehicle_documentation_enable'] }
                },  //permission
            ]
        },
        {
            path: 'maintenance-form-list',
            component: () => import('@/views/vehicle/MaintenanceForm/maintenance-form-list'),
            name: 'MaintenanceFormList',
            meta: { title: 'MaintenanceForm', parent: addInfo, permission: ['maintenance_form_enable'] }
        },
        {
            path: 'maintenance-form',
            component: () => import('@/views/vehicle/MaintenanceForm/maintenance-form'),
            name: 'MaintenanceForm',
            hidden: true,
            meta: { title: 'MaintenanceForm', parent: addInfo, activeMenu: '/vehicle/maintenance-form-list', enableBack: true, backPage: 'MaintenanceFormList', permission: ['maintenance_form_create'] }
        },
        {
            path: 'update-maintenance-form/:id?',
            component: () => import('@/views/vehicle/MaintenanceForm/maintenance-form'),
            name: 'UpdateMaintenanceForm',
            hidden: true,
            meta: { title: 'MaintenanceForm', parent: addInfo, activeMenu: '/vehicle/maintenance-form-list', enableBack: true, backPage: 'MaintenanceFormList', permission: ['maintenance_form_update'] }
        },
        {
            path: 'manage-peripheral',
            name: 'ManagePeripheral',
            meta: { title: 'ManagePeripheral', permission: ['peripheral_device_enable', 'peripheral_api_integration_enable'] },
            children: [
                {
                    path: 'manage-peripheral',
                    component: () => import('@/views/vehicle/ManagePeripheral/manage-peripheral'),
                    name: 'PeripheralDevice',
                    meta: { title: 'PeripheralDevice', parent: addInfo, permission: ['peripheral_device_enable'] }
                },
                {
                    path: 'peripheral-device-form/:id?',
                    component: () => import('@/views/vehicle/ManagePeripheral/peripheral-device-form'),
                    name: 'PeripheralDeviceForm',
                    hidden: true,
                    meta: { title: 'PeripheralDeviceForm', parent: addInfo, activeMenu: '/vehicle/manage-peripheral', enableBack: true, backPage: 'PeripheralDevice', permission: ['peripheral_device_create', 'peripheral_device_update'] }
                },
                {
                    path: 'manage-api-integration',
                    component: () => import('@/views/vehicle/ManagePeripheral/manage-api-integration'),
                    name: 'ApiIntegration',
                    meta: { title: 'ApiIntegration', parent: addInfo, permission: ['peripheral_api_integration_enable'] }
                },
                /*{
                    path: 'api-integration-form/:id?',
                    component: () => import('@/views/vehicle/ManagePeripheral/api-integration-form'),
                    name: 'ApiIntegrationForm',
                    hidden: true,
                    meta: { title: 'ApiIntegrationForm', parent: addInfo, activeMenu: '/vehicle/api-integration', enableBack: true, backPage: 'ApiIntegration' }
                },*/
            ]
        },
        {
            path: 'tools',
            name: 'Tools',
            meta: { title: 'Tools', permission: ['maintenance_category_enable', 'vehicle_industry_enable'] },
            children: [
                {
                    path: 'maintenance-category',
                    component: () => import('@/views/vehicle/Tools/maintenance-category'),
                    name: 'MaintenanceCategory',
                    meta: { title: 'MaintenanceCategory', parent: addInfo, permission: ['maintenance_category_enable'] }
                },
                {
                    path: 'vehicle-industry',
                    component: () => import('@/views/vehicle/Tools/vehicle-industry'),
                    name: 'VehicleIndustry',
                    meta: { title: 'VehicleIndustry', parent: addInfo, permission: ['vehicle_industry_enable'] }
                },
                {
                    path: 'manage-supplier',
                    component: () => import('@/views/tools/ManageSupplier/manage-supplier'),
                    name: 'ManageSupplier',
                    meta: { title: 'ManageSuppliers', parent: addInfo, permission: ['maintenance_supplier_enable', 'maintenance_supplier_create', 'maintenance_supplier_update', 'maintenance_supplier_delete'] }
                },
                {
                    path: 'manage-item-code',
                    component: () => import('@/views/tools/ManageItemCode/manage-item-code'),
                    name: 'ManageItemCode',
                    meta: { title: 'ManageItemCode', parent: addInfo, permission: ['maintenance_item_code_enable', 'maintenance_item_code_create', 'maintenance_item_code_update', 'maintenance_item_code_delete'] }
                },
            ]
        },
    ]
}

export default vehicleRouter
